import React, { useRef } from "react";
import { motion, useInView } from "motion/react";

const DEFAULT_BG = "/img/section2/LINE_NOTE_260109_3.jpg";

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.25, 0.1, 0.25, 1] },
  },
};

export const Section2 = (props) => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.2 });
  const data = props.data ?? {};
  const bg = data.backgroundImage ?? DEFAULT_BG;
  const headline = data.headline ?? null;
  const paragraphs = data.paragraphs ?? []; 
  const leftParagraphs = paragraphs;

  return (
    <section
      ref={sectionRef}
      id="section2"
      className="section2"
      style={{ backgroundImage: `url(${bg})` }}
      aria-label="Yacht party – about the festival"
    >
      <div className="section2__content">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <motion.div
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={containerVariants}
              >
                {(data.partnerLogos ?? []).length > 0 && (
                  <motion.div className="section2__partner-logos" variants={itemVariants}>
                    {(data.partnerLogos ?? []).map((logo, i) => (
                      <React.Fragment key={i}>
                        {i === 1 && <span className="section2__partner-logos-x" aria-hidden="true">×</span>}
                        <img src={logo.url} alt={logo.alt ?? ""} className="section2__partner-logo" loading="lazy" />
                      </React.Fragment>
                    ))}
                  </motion.div>
                )}
                {headline && (
                  <motion.h2
                    className="section2__headline"
                    variants={itemVariants}
                    style={{
                      fontWeight: 1000,
                      fontSize: "60px",
                      lineHeight: "110%",
                      letterSpacing: "0.15em",
                      textAlign: "left",
                      textTransform: "uppercase",
                    }}
                  >
                    {headline}
                  </motion.h2>
                )}
                {leftParagraphs.map((p, i) => (
                  <motion.p
                    key={`left-${i}`}
                    className="section2__paragraph"
                    variants={itemVariants}
                    style={{
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "110%",
                      letterSpacing: "0em",
                      textAlign: "left",
                      textTransform: "uppercase",
                    }}
                  >
                    {p}
                  </motion.p>
                ))}
                {headline && (
                  <motion.h2
                    className="section2__headline"
                    variants={itemVariants}
                    style={{
                      fontWeight: 1000,
                      fontStyle: "italic",
                      fontSize: "32px",
                      lineHeight: "110%",
                      letterSpacing: "0.0em",
                      textAlign: "left",
                      textTransform: "uppercase",
                    }}
                  >
                    WITH OUR PARTNER ONCE "YACHTING PATTAYA"
                  </motion.h2>
                )}
              </motion.div>
            </div>
            <div className="col-xs-12 col-md-6">
              {/* {rightParagraphs.map((p, i) => (
                <p key={`right-${i}`} className="section2__paragraph">
                  {p}
                </p>
              ))} */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
